<template>
  <v-dialog
    v-model="emojiHistory.showing"
    transition="dialog-bottom-transition"
    ligth
    max-width="700"
  >
    <v-card class="mx-auto pt-5">
      <v-card-text>
        <v-card outlined>
          <v-row slot-scope="" justify="center" align="center">
            <v-col cols="auto" v-for="(item, index) in emojiList" :key="index">
              <v-chip class="ma-1" @click="submit(item)">
                {{ item }}
              </v-chip>
            </v-col>
          </v-row>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" variant="text" @click="closeDialog">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    emojiList() {
      return this.$store.state.admin?.admin_details?.details?.emojisList;
    },
    emojiHistory() {
      return this.$store.state.emojiHistory;
    },
  },
  methods: {
    closeDialog() {
      this.emojiHistory.showing = false;
    },
    submit(item) {
      this.$emit("submit", item);
      this.closeDialog();
    },
  },
};
</script>
